// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumUpsellPopover-cls1_wbd","cls2":"PremiumUpsellPopover-cls2_wck PremiumUpsellPopover-cls1_wbd"};